import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { css } from "styled-components";

filterListStyles.filterTag = {
    css: css`
        background: unset;
        color: #696969;
        flex-direction: row-reverse;
        max-width: unset;
        font-weight: 600;
        text-transform: uppercase;
        margin-bottom: 0;
        padding-bottom: 0;
        min-height: unset;
        font-size: 13px;
        padding-left: 0;
        
        button[class^="ButtonWrapper"] {
            background: unset;
            min-height: unset;
            span[class^="IconWrapper"]{
                color: #333;
                top: -1px;
                svg{
                    height: 15px;
                    width: 15px;
                }
            }
        }   
    `
}

filterListStyles.clearAllLink = {
    css: css`
        margin: 15px 0 30px 0;
    `
}

productListFilterAccordionSectionStyles.seeAllLink = {
    css: css`
        span{
            color: #71879F !important;
            font-weight: 600 !important;
        }
    `
}

productListFilterAccordionSectionStyles.seeLessLink = {
    css: css`
        span{
            color: #71879F !important;
            font-weight: 600 !important;
        }
    `
}